import React from 'react';

import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

class PermissionDeniedPage extends React.Component {

    constructor(props) {
        super(props);

        this.props.updateLoader({
            loaded: true,
            message: ""
        });
    }

    render() {
        return (
            <div>
                <h4 className="mb-4">Ограничение доступа</h4>

                <div className="alert alert-warning" role="alert">
                    У Вас недостаточно прав для просмотра запрошенного ресурса
                </div>
            </div>
        );
    }
}

export default PermissionDeniedPage;